function navbar(theme, ownerState) {
  const { transitions, breakpoints, functions } = theme;
  const { absolute, light } = ownerState;
  const { pxToRem } = functions;

  return {
    boxShadow: "0 8px 26px rgba(15,23,42,.055)",
    backdropFilter: `saturate(180%) blur(${pxToRem(18)})`,
    backgroundColor: "rgba(255,255,255,.92) !important",
    color: light ? "#fff" : "#334155",
    top: absolute ? 0 : pxToRem(8),
    minHeight: pxToRem(58),
    display: "grid",
    alignItems: "center",
    borderRadius: 14,
    border: "1px solid #E2E8F0",
    paddingTop: pxToRem(5),
    paddingBottom: pxToRem(5),
    marginBottom: pxToRem(18),
    "& > *": {
      transition: transitions.create("all", {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.standard,
      }),
    },
    "& .MuiToolbar-root": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      [breakpoints.up("sm")]: {
        minHeight: "auto",
        padding: `${pxToRem(3)} ${pxToRem(12)}`,
      },
    },
  };
}

const navbarContainer = ({ breakpoints }) => ({
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "space-between",
  pt: 0.25,
  pb: 0.25,
  [breakpoints.up("md")]: {
    flexDirection: "row",
    alignItems: "center",
    paddingTop: 0,
    paddingBottom: 0,
  },
});

const navbarRow = ({ breakpoints }, { isMini }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  [breakpoints.up("md")]: {
    justifyContent: isMini ? "space-between" : "stretch",
    width: isMini ? "100%" : "max-content",
  },
  [breakpoints.up("xl")]: {
    justifyContent: "stretch !important",
    width: "max-content !important",
  },
});

const navbarIconButton = () => ({
  width: 36,
  height: 36,
  mx: 0.35,
  borderRadius: 10,
  backgroundColor: "#F8FAFC",
  border: "1px solid #E2E8F0",
  transition: "all .18s ease",
  "&:hover": { backgroundColor: "#F0F9FF", borderColor: "#BAE6FD" },
  "& .material-icons, .material-icons-round": { fontSize: "18px !important" },
});

const navbarMobileMenu = ({ breakpoints }) => ({
  width: 36,
  height: 36,
  borderRadius: 10,
  backgroundColor: "#F0F9FF",
  color: "#0284C7",
  border: "1px solid #BAE6FD",
  display: "inline-flex",
  lineHeight: 0,
  [breakpoints.up("xl")]: { display: "none" },
});

export { navbar, navbarContainer, navbarRow, navbarIconButton, navbarMobileMenu };
